<template>
  <div
    class="route-builder-table-expanded-details-row three-col intermediate-shipment"
  >
    <div class="stop cell">
      <LocationTracker :stop-type="ShipmentStopType.UNKNOWN" has-next-stop />

      <KeyValuePair
        :label="t('routeBuilder.intermediateShipments', 2)"
        :value="intermediateShipmentsTooltip"
        class="stop-text"
      >
        <template #value>
          <div
            v-for="intermediateShipment in intermediateShipments"
            :key="intermediateShipment.identifier"
            class="intermediate-shipment-value"
          >
            <ProposedShipmentIcon
              :proposed-shipment="intermediateShipment"
              :title="
                t('routeBuilder.paramOnProposedShipment', {
                  param: t('shipOrders.shipOrders'),
                  proposedShipmentIdentifier: intermediateShipment.identifier,
                })
              "
              class="containing-shipment-icon"
            />

            <LocationMarkers
              :origin="intermediateShipment.origin"
              :destination="intermediateShipment.destination"
              hide-location-icons
            />
          </div>
        </template>
      </KeyValuePair>
    </div>

    <div class="appointment cell"></div>

    <div class="line-items cell">&nbsp;</div>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { ShipmentStopType } from '@/model';
import { RoutePlanProposedShipment } from '@/model/routeBuilder/phase2';

import LocationMarkers from '@/components/location/LocationMarkers.vue';
import LocationTracker from '@/components/location/LocationTracker.vue';
import ProposedShipmentIcon from '@/components/routeBuilder/planningPool/ProposedShipmentIcon.vue';
import KeyValuePair from '@rygen/rygen-ui/components/ui/KeyValuePair.vue';

const props = defineProps({
  intermediateShipments: {
    type: Array as PropType<RoutePlanProposedShipment[]>,
    default: () => [],
  },
});
const { intermediateShipments } = toRefs(props);

const { t } = useI18n();

const intermediateShipmentsTooltip = computed(() => {
  return intermediateShipments.value
    .map((s) => {
      const originCityState = s.origin?.location.cityState ?? '-';
      const destinationCityState = s.destination?.location.cityState ?? '-';
      return `${s.identifier}: ${originCityState} -> ${destinationCityState}`;
    })
    .join('\n');
});
</script>

<style>
/*
Shares .route-builder-table-expanded-details-row styles from 
`RouteBuilderTableExpandedDetailsRow`. Everything below is an override
specifically for intermediate shipments
*/
.route-builder-table-expanded-details-row.three-col.intermediate-shipment {
  .cell {
    &.stop {
      .location-tracker {
        align-items: end;

        .info-icon-container {
          height: 50%;
        }
      }

      .stop-text {
        display: flex;
        flex-flow: column;
        gap: var(--sp-1);
        width: 100%;

        .key-value-pair-value {
          padding: var(--sp-3) 0;

          .intermediate-shipment-value {
            display: flex;
            gap: var(--gap-1);
            align-items: center;

            .location-markers {
              gap: var(--sp-1);
            }
          }
        }
      }
    }
  }
}
</style>
